import Quotation, {
  makeEmptyQuotation,
} from 'data-layer-cr/dist/models/Quotation';
import QuotationCoverage, {
  makeEmptyQuotationCoverage,
} from 'data-layer-cr/dist/models/QuotationCoverage';
import QuotationUnit, {
  makeEmptyQuotationUnit,
} from 'data-layer-cr/dist/models/QuotationUnit';
import { PricingV4Quotation } from '../PricingV4Response';

export const makeQuotationFromPricingV4 = (
  data: PricingV4Quotation,
): Quotation => {
  const newQuotation = makeEmptyQuotation();
  newQuotation.hasMultipleOptions = data.hasMultipleOptions;
  newQuotation.isAutoPx = data.autoPx;
  const unitArray: QuotationUnit[] = data.certificates.map((certificate) => {
    const helperUnit = makeEmptyQuotationUnit();
    helperUnit.total = {
      discounts: [],
      grandTotal: certificate.total.grandTotal,
      subTotal: certificate.total.subTotal,
      tax: certificate.total.tax,
      taxRate: 0,
    };
    helperUnit.package = {
      description: certificate.package.package,
      order: certificate.package.order,
      id: certificate.package.option,
      isDefault: certificate.package.default,
    };
    helperUnit.coverages = certificate.coverages.map(
      (coverage): QuotationCoverage => {
        const newCoverage = makeEmptyQuotationCoverage();
        newCoverage.coreBranch = coverage.lineCode;
        newCoverage.coverageId = coverage.coverageCode;
        newCoverage.deductible = coverage.deductibleAmount;
        newCoverage.deductibleRate = coverage.deductiblePercentage;
        newCoverage.insuredValue = coverage.sumInsured;
        newCoverage.deductibleDescription = coverage.coverageDescription;
        return newCoverage;
      },
    );
    return helperUnit;
  });
  newQuotation.units = unitArray;
  return newQuotation;
};

export default makeQuotationFromPricingV4;
